"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import dynamic from "next/dynamic";
import Button from "@/components/ui/button";
import { Dialog, DialogBody, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useUser } from "@/contexts/user-provider";
import { PERMISSIONS, hasPermission } from "@/lib/permissions";
const TodaysAppointments = dynamic(() => import("@/components/right-sidebar/patient/todays-appointments").then(module => module.TodaysAppointments));
export function GalleryAppointmentButton(t0) {
  const $ = _c(6);
  const {
    eventId
  } = t0;
  const [open, setOpen] = useState(false);
  const {
    currentUser
  } = useUser();
  if (!hasPermission(currentUser, PERMISSIONS.SCHEDULING_READ)) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button variant="ghost" size="sm" onClick={() => setOpen(true)}>View appointment</Button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== eventId || $[2] !== open) {
    t2 = open && <Dialog open={open} onOpenChange={setOpen}><DialogContent className="max-w-lg"><DialogHeader><DialogTitle>Appointment Details</DialogTitle></DialogHeader><DialogBody><TodaysAppointments eventId={eventId} /></DialogBody><DialogFooter><DialogClose>Close</DialogClose></DialogFooter></DialogContent></Dialog>;
    $[1] = eventId;
    $[2] = open;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}